import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';

const PostDetailsContainer = ({ productTiles }) => {
    return productTiles ? (
        <Box
            display={['flex', 'flex', 'grid', 'grid']}
            flexWrap={['wrap', 'wrap', null, null]}
            width={['100%', '100%', 698, 698]}
            maxWidth={[null, 343, null, null]}
            flexDirection={['column']}
            gridTemplateColumns={[null, null, '1fr', '1fr 1fr']}
            gridTemplateRows={[null, null, 'auto', 'auto auto']}
            alignItems={['flex-start', 'flex-start', 'start', 'start']}
            justifyItems={[null, null, 'start', 'start']}
            gap={[2, 3, 3, 3]}
        >
            {productTiles}
        </Box>
    ) : (
        <div />
    );
};

PostDetailsContainer.propTypes = {
    children: PropTypes.node,
    productTiles: PropTypes.node
};

export default wrapFunctionalComponent(PostDetailsContainer, 'PostDetailsContainer');
